import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { InformationEntityComponent } from '../../../../shared/components/information-entity/information-entity.component';
import { AccordionModule } from 'primeng/accordion';
import { IConversationDetails } from '../../../../shared/models/conversation-details.model';
import { DatePipe } from '@angular/common';
import { AgentFieldComponent } from '../agent-field/agent-field.component';

@Component({
  selector: 'cv-conversation-details',
  standalone: true,
  templateUrl: './conversation-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [InformationEntityComponent, AccordionModule, DatePipe, AgentFieldComponent],
})
export class ConversationDetailsComponent {
  @Input({ required: true }) data: IConversationDetails = {} as IConversationDetails;
}
